"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.function.bind");

require("core-js/modules/es.function.name");

require("core-js/modules/es.number.to-fixed");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.parse-float");

require("core-js/modules/es.parse-int");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _formElements = require("@evidation/form-elements");

var _components = require("./components");

var _react = _interopRequireDefault(require("react"));

var _preview = _interopRequireDefault(require("./preview"));

var _lodash = _interopRequireDefault(require("lodash"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var formatBytes = function formatBytes(bytes) {
  var decimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (0 === bytes) {
    return '0 Bytes';
  }

  var c = 1024;
  var e = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var f = Math.floor(Math.log(bytes) / Math.log(c));
  return parseFloat((bytes / Math.pow(c, f)).toFixed(decimal)) + ' ' + e[f];
};

var ReactImageUploadComponent = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(ReactImageUploadComponent, _React$PureComponent);

  var _super = _createSuper(ReactImageUploadComponent);

  function ReactImageUploadComponent(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ReactImageUploadComponent);
    _this = _super.call(this, props);
    _this.state = {
      files: [],
      pictures: [],
      notAcceptedFileType: [],
      notAcceptedFileSize: [],
      errors: []
    };
    _this.inputElement = '';
    _this.onDropFile = _this.onDropFile.bind((0, _assertThisInitialized2["default"])(_this));
    _this.triggerFileUpload = _this.triggerFileUpload.bind((0, _assertThisInitialized2["default"])(_this));
    _this.generatePreview = _this.generatePreview.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(ReactImageUploadComponent, [{
    key: "triggerFileUpload",
    value: function triggerFileUpload() {
      var _this2 = this;

      this.setState({
        errors: []
      }, function () {
        _this2.props.input.onFocus();

        _this2.inputElement.click();
      });
    }
  }, {
    key: "onDropFile",
    value: function onDropFile(incomingFiles) {
      var _this$state = this.state,
          pictures = _this$state.pictures,
          files = _this$state.files;
      var maxFiles = this.props.maxFiles;
      var MaxFiles = parseInt(maxFiles, 10);
      var filesObject = files;
      var errors = [];

      if (incomingFiles.length + pictures.length > MaxFiles) {
        errors = ["Files not uploaded due to number of files. Please upload up to ".concat(MaxFiles, " photos and try again.")];
      } else {
        filesObject = _lodash["default"].concat(filesObject, _lodash["default"].toArray(incomingFiles));
      }

      this.generatePreview({
        files: filesObject,
        errors: errors
      });
    }
  }, {
    key: "generatePreview",
    value: function generatePreview(_ref) {
      var _this3 = this;

      var _ref$files = _ref.files,
          files = _ref$files === void 0 ? [] : _ref$files,
          _ref$errors = _ref.errors,
          lengthErrors = _ref$errors === void 0 ? [] : _ref$errors;
      this.props.readMultipleFiles({
        files: files,
        errors: lengthErrors
      }).then(function (_ref2) {
        var results = _ref2.results,
            _ref2$errors = _ref2.errors,
            errors = _ref2$errors === void 0 ? [] : _ref2$errors;
        return _this3.setState({
          files: _lodash["default"].reduce(results, function (acc, file) {
            return [].concat((0, _toConsumableArray2["default"])(acc), [file.file]);
          }, []),
          pictures: _lodash["default"].reduce(results, function (acc, _ref3) {
            var file = _ref3.file,
                rest = (0, _objectWithoutProperties2["default"])(_ref3, ["file"]);
            return [].concat((0, _toConsumableArray2["default"])(acc), [rest]);
          }, []),
          errors: [].concat((0, _toConsumableArray2["default"])(errors), (0, _toConsumableArray2["default"])(lengthErrors))
        }, function () {
          return _this3.props.onChange(results);
        });
      });
    }
  }, {
    key: "removeImage",
    value: function removeImage(name) {
      var _this4 = this;

      this.setState({
        errors: []
      }, function () {
        _this4.inputElement.value = null;

        var files = _lodash["default"].filter(_this4.state.files, function (n) {
          return n.name !== name;
        });

        _this4.generatePreview({
          files: files
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props = this.props,
          buttonText = _this$props.buttonText,
          buttonStyle = _this$props.buttonStyle,
          name = _this$props.name,
          accept = _this$props.accept,
          _this$props$meta = _this$props.meta,
          error = _this$props$meta.error,
          touched = _this$props$meta.touched,
          label = _this$props.label,
          maxFileSize = _this$props.maxFileSize,
          maxFiles = _this$props.maxFiles,
          disabled = _this$props.disabled;
      var _this$state2 = this.state,
          errors = _this$state2.errors,
          loading = _this$state2.loading,
          pictures = _this$state2.pictures;

      var allErrors = _lodash["default"].without([].concat((0, _toConsumableArray2["default"])(errors), [error]), undefined);

      return /*#__PURE__*/_react["default"].createElement(_components.Uploader, null, /*#__PURE__*/_react["default"].createElement(_components.Container, null, this.renderPreview(pictures)), /*#__PURE__*/_react["default"].createElement(_components.ErrorsContainer, null, this.renderErrors()), !loading && touched && /*#__PURE__*/_react["default"].createElement("ul", null, _lodash["default"].map(allErrors, function (e) {
        return /*#__PURE__*/_react["default"].createElement(_formElements.InputError, {
          key: e
        }, e);
      })), label && /*#__PURE__*/_react["default"].createElement(_components.FileUploadLabel, null, /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, label)), /*#__PURE__*/_react["default"].createElement(_components.FileUploadLabel, null, "Files must be under ", formatBytes(parseInt(maxFileSize, 10) * 0.75), ' ', "and in ", this.props.imgExtension.join(', '), " format. PDF files will not be accepted."), /*#__PURE__*/_react["default"].createElement(_formElements.Button, {
        isLoading: loading,
        disabled: loading || maxFiles === pictures.length || disabled,
        buttonStyle: buttonStyle,
        onClick: this.triggerFileUpload
      }, buttonText), /*#__PURE__*/_react["default"].createElement("input", {
        type: "file",
        ref: function ref(input) {
          return _this5.inputElement = input;
        },
        name: name,
        multiple: "multiple",
        onChange: function onChange(e) {
          var files = e.target.files;

          _this5.setState({
            errors: []
          }, function () {
            return _this5.onDropFile(files);
          });
        },
        accept: accept
      }));
    }
  }, {
    key: "renderErrors",
    value: function renderErrors() {
      var _this6 = this;

      var notAccepted = '';

      if (this.state.notAcceptedFileType.length > 0) {
        notAccepted = this.state.notAcceptedFileType.map(function (error, index) {
          return /*#__PURE__*/_react["default"].createElement(_formElements.InputError, {
            key: index
          }, "* ", error, " ", _this6.props.fileTypeError);
        });
      }

      if (this.state.notAcceptedFileSize.length > 0) {
        notAccepted = this.state.notAcceptedFileSize.map(function (error, index) {
          return /*#__PURE__*/_react["default"].createElement(_formElements.InputError, {
            key: index
          }, "* ", error, " ", _this6.props.fileSizeError);
        });
      }

      return notAccepted;
    }
  }, {
    key: "renderPreview",
    value: function renderPreview(pictures) {
      var _this7 = this;

      var EmptyContainers = _lodash["default"].map(Array(this.props.maxFiles - pictures.length), function (key, i) {
        return /*#__PURE__*/_react["default"].createElement(_components.UploadPictureContainer, {
          key: i,
          onClick: _this7.triggerFileUpload
        });
      });

      return /*#__PURE__*/_react["default"].createElement(_components.UploadPicturesWrapper, null, pictures.length !== 0 && this.renderPreviewPictures(pictures), EmptyContainers);
    }
  }, {
    key: "renderPreviewPictures",
    value: function renderPreviewPictures(pictures) {
      var _this8 = this;

      return _lodash["default"].map(pictures, function (_ref4) {
        var base64 = _ref4.base64,
            rest = (0, _objectWithoutProperties2["default"])(_ref4, ["base64"]);
        return /*#__PURE__*/_react["default"].createElement(_preview["default"], (0, _extends2["default"])({}, rest, {
          img: base64,
          key: rest.name,
          disabled: _this8.props.disabled,
          onClick: function onClick() {
            return _this8.removeImage(rest.name);
          }
        }));
      });
    }
  }]);
  return ReactImageUploadComponent;
}(_react["default"].PureComponent);

var _default = ReactImageUploadComponent;
exports["default"] = _default;